module.exports = __webpack_public_path__ + "img/diangugushi@3x.40cf32bd.png";